import { NotificationManager } from 'react-notifications';
import axios, { AxiosError } from 'axios';
import { IQueryParams } from 'src/types';

import { IPayoutAvailableMethod, IPayoutAvailableMethodData, ISearchPayoutSystemGroupForm } from './types';

const AVAILABLE_METHODS_URL = 'api/v1/payout/available-methods';

export const fetchPayoutAvailableMethodsRequest = async ({
  page,
  size,
  sort,
  ...data
}: IQueryParams): Promise<IPayoutAvailableMethodData | null> => {
  try {
    const res = await axios.post(AVAILABLE_METHODS_URL, data, { params: { page, size, sort } });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch available methods");
    return null;
  }
};

export const fetchPayoutAvailableMethodRequest = async (id: string): Promise<Partial<IPayoutAvailableMethod> | null> => {
  try {
    const res = await axios.get(`${AVAILABLE_METHODS_URL}/${id}`);
    return res.data;
  } catch (error) {
    const err = error as AxiosError<{ errorMessage: string }>;
    NotificationManager.error(err.response?.data?.errorMessage);
    return null;
  }
};

export const createPayoutAvailableMethodRequest = async (
  data: Partial<IPayoutAvailableMethod>,
): Promise<Partial<IPayoutAvailableMethod>> => {
  try {
    const res = await axios.put(AVAILABLE_METHODS_URL, data);
    NotificationManager.success('Available method has been created');
    return res.data;
  } catch (error) {
    const err = error as AxiosError<{ errorMessage: string }>;
    NotificationManager.error(err.response?.data?.errorMessage);
    throw new Error(err.response?.data?.errorMessage);
  }
};

export const updatePayoutAvailableMethodsRequest = async ({
  id,
  ...data
}: Partial<IPayoutAvailableMethod>): Promise<Partial<IPayoutAvailableMethod>> => {
  try {
    const res = await axios.post(`${AVAILABLE_METHODS_URL}/${id}`, data);
    NotificationManager.success('Available method has been updated');
    return res.data;
  } catch (error) {
    const err = error as AxiosError<{ errorMessage: string }>;
    NotificationManager.error(err.response?.data?.errorMessage);
    throw new Error(err.response?.data?.errorMessage);
  }
};

export const deletePayoutAvailableMethodsRequest = async (id: number): Promise<void> => {
  try {
    await axios.delete(`${AVAILABLE_METHODS_URL}/${id}`);
    NotificationManager.success('Available method has been deleted');
  } catch (error) {
    const err = error as AxiosError<{ errorMessage: string }>;
    NotificationManager.error(err.response?.data?.errorMessage);
    throw new Error(err.response?.data?.errorMessage);
  }
};

export const fetchPayoutSystemGroupFormFilter = async (): Promise<ISearchPayoutSystemGroupForm[]> => {
  const res = await axios.get(`api/v1/payout/search-filter/system-group-form`);
  return res.data;
};

export const fetchPaymentSystemGroupFormFilter = async (): Promise<ISearchPayoutSystemGroupForm[]> => {
  const res = await axios.get(`api/v1/payment/search-filter/system-group-form`);
  return res.data;
};
